import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
} from "@material-ui/core";
import { EditConsentTypeGroupDTO } from "../../../models/ConsentTypeGroups";

interface Props {
  group: ConsentTypeGroupDTO;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: EditConsentTypeGroupDTO) => void;
}

const EditGroupDialog: React.FC<Props> = ({
  group,
  isOpen,
  onClose,
  onSubmit,
}) => {
  const [name, setName] = React.useState<string>(group.name);

  React.useEffect(() => {
    setName(group.name);
  }, [group]);

  function submit() {
    if (name == null || name === "") {
      // TODO: Show error
      return;
    }

    onSubmit({ name });
  }

  return (
    <Dialog open={isOpen} onClose={onClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Edit consent type group</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="Name"
          fullWidth
          value={name}
          onChange={(event) => setName(event.target.value)}
          required
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          type="submit"
          onClick={submit}
          variant="contained"
          color="primary"
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditGroupDialog;
